import React, { memo } from 'react'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid2'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Image from 'next/legacy/image'

// Estilos
import sx from './styles'

const stepsData = [
  {
    id: 1,
    title: 'COMPARTE TUS DATOS',
    description: 'Ingresa los datos de tu auto y tus datos de contacto para validar si es candidato para One Day.',
    icon: '/oneday_assets/oneday_icons/share_data.svg',
  },
  {
    id: 2,
    title: 'AGENDA TU CITA',
    description: 'Elige el día y la hora que prefieras para revisar tu auto con nuestro equipo.',
    icon: '/oneday_assets/oneday_icons/calendar.svg',
  },
  {
    id: 3,
    title: 'INSPECCIÓN EXPRESS',
    description: 'Nuestros técnicos inspeccionan el estado de tu auto para definir una oferta inicial clara y competitiva.',
    icon: '/oneday_assets/oneday_icons/inspection.svg',
  },
  {
    id: 4,
    title: 'OFERTA ONE DAY',
    description: 'Tu auto participa durante 24 horas y los compradores compiten para ofrecer el mejor precio.',
    icon: '/oneday_assets/oneday_icons/subasta.svg',
  },
  {
    id: 5,
    title: 'RECIBE TU PAGO',
    description: 'Si aceptas la oferta final, recibes tu pago de forma rápida, segura y sin complicaciones.',
    icon: '/oneday_assets/oneday_icons/payment.svg',
  },
]

const HowItWorks = () => {
  return (
    <Box
      component="section"
      sx={sx.container}
      id="HowItWorks"
    >
      <Container maxWidth="xl">
        <Typography
          component="h2"
          variant="inherit" // <-- Esto desactiva el body1 por defecto
          sx={sx.mainTitle}
        >
          CÓMO FUNCIONA
        </Typography>

        <Grid
          container
          spacing={2}
          justifyContent="center"
          alignItems="stretch"
        >
          {stepsData.map((step) => (
            <Grid
              key={`step-${step.id}`}
              size={{ xs: 12, sm: 6, md: 'grow' }}
            >
              <Box sx={sx.card}>
                {/* Etiqueta del número */}
                <Box sx={sx.numberTag}>
                  {step.id}
                </Box>

                {/* Ícono */}
                <Box sx={sx.iconContainer}>
                  <Image
                    src={step.icon}
                    alt={step.title}
                    width={48}
                    height={48}
                    layout="fixed"
                  />
                </Box>

                {/* Textos */}
                <Typography
                  component="h3"
                  variant="inherit"
                  sx={sx.cardTitle}
                >
                  {step.title}
                </Typography>
                <Typography
                  component="p"
                  variant="inherit"
                  sx={sx.cardDescription}
                >
                  {step.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  )
}

export default memo(HowItWorks)
